import ATag from './Tag';
export default ATag;


// WEBPACK FOOTER //
// ./src/packages/Tag/index.js